/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="basicEmailMarketing.module.ts" />

module Meevo.Plugins.BasicEmailMarketing {

    import BasicMarketingDateRangeSelectionEnum = Meevo.Model.BasicMarketingDateRangeSelectionEnum;
    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import AppAreaEnum = Meevo.Model.AppAreaEnum;
    import SalesTypeEnum = Meevo.Model.SalesTypeEnum;
    import ControlTypeEnum = Meevo.Model.ControlTypeEnum;
    import PackageType = Meevo.Model.PackageType;
    import ISelectItem = Meevo.Model.ISelectItem;

    interface IEmailMarketingClient {
        Id: string;
        Prefix: string;
        FirstName: string;
        LastName: string;
        Address1: string;
        Address2: string;
        City: string;
        State: string;
        ZipCode: string;
        HomePhoneNumber: string;
        MobilePhoneNumber: string;
        WorkPhoneNumber: string;
        WorkPhoneExtension: string;
        PrimaryPhoneType: string;
        EmailAddress: string;
        EmailCommOptedInStateEnum: string;
        IsMarketingEmailEnabled: string;
        FirstVisitDate: string;
        LastVisitDate: string;
        GenderEnum: string;
        BirthYear: string;
        BirthMonth: string;
        BirthDay: string;
        AnniversaryDate: string;
        ClientType: string;
        IsMinor: string;
        IsRestricted: string;
        IsTransient: string;
        ExcludeFromReceivingPoints: string;
        AllowChargesCreditOnAccount: string;
    }

    const MAX_SELECT_UDFS = 10;

    interface IUdf extends IUserDefinedControl {
        position?: number;
    }

    class BasicEmailMarketingController {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.busy.BusyService",
            "$rootScope",
            "$timeout",
            "$state",
            '$translate',
            "meevo.components.common.ReportRouterService"
        ];

        public disableExport = true;
        public includeInactive = false;
        public noFutureAppointments = false;
        public neverPurchasedRetail = true;
        public clientSelectionId = Meevo.Model.BasicMarketingClientSelectionEnum.ActiveClient;
        public numberOfVisits = 1;
        public numberOfVisitsOptions = [];
        private maxAmountOfVisits = 52;

        public membershipStatusId: string = null;

        public clientSelectionNames = [];
        public exportSecurityKey = Meevo.Components.Common.SecurityKeys.MARKETING_BASICMARKETING_ACTION_EXPORT;
        public dateRanges = [];
        public dateRangesCompare = [];
        public dateRangeCompare: number;
        public userCount = 0;
        public timeInterval = 1;
        public hiddenCompareLabelIds = [
            Meevo.Model.BasicMarketingClientSelectionEnum.Birthday,
            Meevo.Model.BasicMarketingClientSelectionEnum.ReferralVisits
        ];
        public serviceCategories: any = null;
        public services: any = null;
        public productCategories: any = null;
        public products: any = null;
        public productCriteria: any;
        public productCategoryCriteria: any;
        public employeeCriteria: any;
        public serviceCriteria: any;
        public serviceCategoryCriteria: any;
        public membershipCriteria: any;
        public membershipTypeCriteria: any;
        public isCentralOffice: boolean;
        public businessInfoSettings: any = null;
        public giftCardTypeCriteria: any;
        public discountsCriteria: any;

        public AnyService: Model.Service = {
            id: null,
            displayName: "Any Service"
        };

        public AnyActiveService: Model.Service = {
            id: null,
            displayName: "Any Active Service"
        }

        public AnyServiceCategory: Model.ServiceCategory = {
            id: null,
            displayName: "Any Service Category"
        };

        public AnyActiveServiceCategory: Model.ServiceCategory = {
            id: null,
            displayName: "Any Active Service Category"
        };

        public AnyProductVariant: Model.Product = {
            id: null,
            displayName: "Any Product"
        };

        public AnyProductCategory: Model.ProductCategory = {
            id: null,
            displayName: "Any Product Category"
        };

        public AnyMembership = {
            id: null,
            displayName: "Any Membership"
        };

        public AnyActiveMembership = {
            id: null,
            displayName: "Any Active Membership"
        };


        public AnyMembershipType = {
            id: null,
            displayName: "Any Membership Type"
        };

        public AnyActiveMembershipType = {
            id: null,
            displayName: "Any Active Membership Type"
        };

        public AnyGiftCardType = {
            id: null,
            displayName: "Any Gift Card Type"
        };

        public AnyActiveGiftCardType = {
            id: null,
            displayName: "Any Active Gift Card Type"
        };

        public AnyDiscount = {
            id: null,
            displayName: "Any predefined discount"
        };

        public AnyActiveDiscount = {
            id: null,
            displayName: "Any active predefined discount"
        };

        public AnyEmployee: Model.EmployeeListItem = {
            id: null,
            displayName: "Any Employee",
            lastName: "ANY",
            firstName: "EMPLOYEE",
            code: "ANY",
            isEmployee: false,
            allowSales: false,
            allowTips: false
        };
        public AnyActiveEmployee: Model.EmployeeListItem = {
            id: null,
            displayName: "Any Active Employee",
            lastName: "ANY ACTIVE",
            firstName: "EMPLOYEE",
            code: "ANY ACTIVE",
            isEmployee: false,
            allowSales: false,
            allowTips: false
        };

        public AnyPackage = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_PACKAGE')
        }

        public AnyActivePackage = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_ACTIVE_PACKAGE')
        }

        public employee: any = this.AnyActiveEmployee;
        public service: any = this.AnyActiveService;
        public serviceCategory: any = this.AnyActiveServiceCategory;
        public productVariant: any = this.AnyProductVariant;
        public productCategory: any = this.AnyProductCategory;
        public membership: any = this.AnyActiveMembership;
        public membershipType: any = this.AnyActiveMembershipType;
        public serviceCategory_Tbl: any = [];
        public productCategory_Tbl: any = [];

        public membershipStatuses: any = [
            {
                id: null,
                displayName: "LABEL_ALL_MEMBERS"
            },
            {
                id: Meevo.Model.ClientMembershipSearchStatusEnum.Active,
                displayName: "LABEL_ACTIVE"
            },
            {
                id: Meevo.Model.ClientMembershipIndicatorStatusEnum.Frozen,
                displayName: "LABEL_FROZEN"
            },
            {
                id: Meevo.Model.ClientMembershipIndicatorStatusEnum.InCancellation,
                displayName: "LABEL_IN_CANCELLATION"
            },
            {
                id: Meevo.Model.ClientMembershipIndicatorStatusEnum.Suspended,
                displayName: "LABEL_SUSPENDED"
            },
            {
                id: Meevo.Model.ClientMembershipSearchStatusEnum.Expired,
                displayName: "LABEL_EXPIRED"
            }
        ];
        public requireMarketingOptIn: boolean = false;
        public gender: string = '';
        public noVisitsSince: string;
        public discount: any = this.AnyActiveDiscount;
        public onlyGrandFatheredMemberships: boolean;
        public onlySuspendedMemberships: boolean
        public giftCardType: any = this.AnyActiveGiftCardType;
        public giftCardStatus: any = 0;
        public expireStartDate: string;
        public expireEndDate: string;
        public minBalance: any = 0;
        public maxBalance: any = 0;
        public includeMembers: boolean = true;
        public includeNonMembers: boolean = true;
        public minPoints: any = 0;
        public maxPoints: any = 0;
        public isForReferringClients: boolean = false;
        public filterDateRanges: IDateRange[] = [];
        public showEmmaButton: boolean = false;
        public startDate = null;
        public endDate = null;
        public mainForm;
        public optedInFotMessage: boolean = false;
        public amountItemTypeOptions = [
            {label: 'LABEL_SERVICES_AND_PRODUCTS', value: AmountItemTypeEnum.ServicesAndProducts},
            {label: 'LABEL_SERVICES', value: AmountItemTypeEnum.Services},
            {label: 'LABEL_PRODUCTS', value: AmountItemTypeEnum.Products},
        ];
        public requireTextMarketingOptIn: boolean = false;
        public hideInactiveEmployees: boolean = true;


        public includeInactiveMemberships: boolean = false;
        public includeInactiveAmountItemType: boolean = false;
        public includeInactiveServices: boolean = false;
        public includeInactiveGC: boolean = false;
        public includeInactivePackage: boolean = false;
        public includeDiscontinuedProducts: boolean = false;
        public includeInactiveDiscounts: boolean = false;

        public amountModel: IAmountModel = {
            min: 0,
            max: 0,
            amountItemType: AmountItemTypeEnum.ServicesAndProducts,
            services: [],
            serviceCategories: [],
            products: [],
            productCategories: [],
            employees: [],
            employeeCategories: [],
        };

        public udfsModel: IUdf[] = [];
        public newUdf: IUserDefinedControl = null;

        public allowedControlTypes: Array<ControlTypeEnum> = [];

        public udfCriteria = {
                shortcut: null,
                controlTypeEnum: null,
                appAreaEnum: AppAreaEnum.Client,
                objectStateEnums: [ObjectStateEnum.Active]
        };

        public purchasedANotBModel: IPurchasedANotB;

        public package: PackageType;

        public packageStatusOptions: ISelectItem<boolean>[] = [
            {value: null, label: 'LABEL_INCLUDE_ACTIVE_AND_EXPIRED_PACKAGES'},
            {value: false, label: 'LABEL_INCLUDE_ACTIVE_PACKAGES'},
            {value: true, label: 'LABEL_INCLUDE_EXPIRED_PACKAGES'},
        ];
        public packageStatusModel = null;

        public packageBalanceOptions: ISelectItem<boolean>[] = [
            {value: null, label: 'LABEL_INCLUDE_ALL_BALANCE_NO_BALANCE'},
            {value: true, label: 'LABEL_INCLUDE_WITH_BALANCE'},
            {value: false, label: 'LABEL_INCLUDE_WITH_NO_BALANCE'},
        ];
        public packageBalanceModel = null;

        public get headerNote(): string {
            let eventCode = this.selectedEventCode;

            return !!eventCode ? 'LABEL_CLIENT_SELECTION_EXPORT_NOTE_' + eventCode.toUpperCase() : '';
        }

        public get selectedEventCode(): string {
            let clientSelectionName = this.clientSelectionNames.find((item) => item.id === this.clientSelectionId);

            return clientSelectionName ? clientSelectionName.code : null;
        }

        public get clientExportUDFs() {
            return this.udfsModel.reduce((model, udf) => {
                model[udf.control_TId.toString()] = udf.position;

                return model;
            }, {})
        }

        //#region show/hide components logic
        public get showFutureAppointments(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ReferralVisits,
                BasicMarketingClientSelectionEnum.NewClient,
                BasicMarketingClientSelectionEnum.OverdueClients,
                BasicMarketingClientSelectionEnum.LastVisitNoFutureAppntmnt,
                BasicMarketingClientSelectionEnum.ClientsWithCertainAmountOfVisits,
                BasicMarketingClientSelectionEnum.ClientsWithDiscounts,
                BasicMarketingClientSelectionEnum.ClientsPurchasedGiftCard,
                BasicMarketingClientSelectionEnum.ClientsWithPoints,
                BasicMarketingClientSelectionEnum.ClientsThatHaveReceivedServiceFromEmployee,
                BasicMarketingClientSelectionEnum.ClientsWithMembershipAboutToExpire,
                BasicMarketingClientSelectionEnum.ClientsThatHaveNoShowed,
                BasicMarketingClientSelectionEnum.ClientsPurchasedServiceAnotServiceB,
                BasicMarketingClientSelectionEnum.ClientsPurchasedProductAnotProductB,
                BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct,
                BasicMarketingClientSelectionEnum.ClientsReceivedPackage,
                BasicMarketingClientSelectionEnum.ClientsPurchasedPackage,
                BasicMarketingClientSelectionEnum.ClientsAreDueIn,
                BasicMarketingClientSelectionEnum.ClientsSpentXamountOnServicesAndProducts,
                BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase,
                BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase,
                BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf,
                BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase,
                BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showPurchasedANotB(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsPurchasedProductAnotProductB,
                BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct,
                BasicMarketingClientSelectionEnum.ClientsPurchasedServiceAnotServiceB,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showIncludeDiscontinuedProducts(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsPurchasedProductAnotProductB,
                BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showIncludeInactiveServices(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsThatHaveReceivedServiceFromEmployee,
                BasicMarketingClientSelectionEnum.ClientsAreDueIn,
                BasicMarketingClientSelectionEnum.ClientsWithAnAppointmentBooked,
                BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct,
                BasicMarketingClientSelectionEnum.ClientsPurchasedServiceAnotServiceB,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showGender(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ActiveClient,
                BasicMarketingClientSelectionEnum.AllClients,
                BasicMarketingClientSelectionEnum.Birthday,
                BasicMarketingClientSelectionEnum.ClientsWithMembership,
                BasicMarketingClientSelectionEnum.LastVisitNoFutureAppntmnt,
                BasicMarketingClientSelectionEnum.NewClient,
                BasicMarketingClientSelectionEnum.ClientsWithCertainAmountOfVisits,
                BasicMarketingClientSelectionEnum.ClientsThatHaveReceivedServiceFromEmployee,
                BasicMarketingClientSelectionEnum.ClientsWithDiscounts,
                BasicMarketingClientSelectionEnum.ClientsPurchasedProductAnotProductB,
                BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct,
                BasicMarketingClientSelectionEnum.ClientsPurchasedServiceAnotServiceB,
                BasicMarketingClientSelectionEnum.ClientsReceivedPackage,
                BasicMarketingClientSelectionEnum.ClientsPurchasedPackage,
                BasicMarketingClientSelectionEnum.ClientsAreDueIn,
                BasicMarketingClientSelectionEnum.ClientsPurchasedGiftCard,
                BasicMarketingClientSelectionEnum.ClientsWithGiftCardBalance,
                BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase,
                BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase,
                BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf,
                BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase,
                BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showPackage(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsReceivedPackage,
                BasicMarketingClientSelectionEnum.ClientsPurchasedPackage,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showHavePackage(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsReceivedPackage,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showPackageBalanceSelect(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsReceivedPackage,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showPackageStatusSelect(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsReceivedPackage,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showServiceCategory(): boolean {
            return [
                BasicMarketingClientSelectionEnum.NewClient,
                BasicMarketingClientSelectionEnum.OverdueClients,
                BasicMarketingClientSelectionEnum.ClientsThatHaveReceivedServiceFromEmployee,
                BasicMarketingClientSelectionEnum.ClientsAreDueIn,
                BasicMarketingClientSelectionEnum.ClientsWithAnAppointmentBooked,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showService(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsThatHaveReceivedServiceFromEmployee,
                BasicMarketingClientSelectionEnum.ClientsAreDueIn,
                BasicMarketingClientSelectionEnum.ClientsWithAnAppointmentBooked,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showHideInactiveEmployees(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsWithAnAppointmentBooked,
                BasicMarketingClientSelectionEnum.LastVisitNoFutureAppntmnt,
                BasicMarketingClientSelectionEnum.ClientsWithCertainAmountOfVisits,
                BasicMarketingClientSelectionEnum.ClientsThatHaveReceivedServiceFromEmployee,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showProductCategory(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase,
                BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase,
                BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf,
                BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase,
                BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        public get showProduct(): boolean {
            return [
                BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase,
                BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase,
                BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf,
                BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase,
                BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf,
            ].indexOf(this.clientSelectionId) !== -1;
        }

        //#region show/hide components logic

        public get amountItemType(): SalesTypeEnum[] {
            return {
                [AmountItemTypeEnum.Products]: [SalesTypeEnum.Product],
                [AmountItemTypeEnum.Services]: [SalesTypeEnum.Service],
                [AmountItemTypeEnum.ServicesAndProducts]: [SalesTypeEnum.Service, SalesTypeEnum.Product],
            }[this.amountModel.amountItemType] || null;
        }

        public get serviceCategoryTblIds(): string[] {
            if (this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct) {
                return this.purchasedANotBModel.fullModel.ServiceCategoryId;
            }

            return this.serviceCategory_Tbl && this.serviceCategory_Tbl.filter((x) => x === '0').length === 0 ? this.serviceCategory_Tbl : null;
        }

        public get serviceListTbl(): string[] {
            if (this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct) {
                return this.purchasedANotBModel.fullModel.ServiceId;
            }

            if (this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsSpentXamountOnServicesAndProducts) {
                return this.amountModel.services;
            }

            return null;
        }

        public get productCategoryTblIds(): string[] {
            if (   this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase 
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf) {
                return this.purchasedANotBModel.fullModel.ProductCategoryId;
            }

            return this.productCategory_Tbl && this.productCategory_Tbl.filter((x) => x === '0').length === 0 ? this.productCategory_Tbl : null;
        }
        public get productCategoryListTbl(): string[] {
            if (   this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf) {
                return this.purchasedANotBModel.fullModel.NotProductCategoryId;
            }

            if (this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsSpentXamountOnServicesAndProducts) {
                return this.amountModel.productCategories;
            }

            return null;
        }

        public get productListTbl(): string[] {
            if (this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct) {
                return this.purchasedANotBModel.fullModel.NotProductId;
            }

            if (this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsSpentXamountOnServicesAndProducts) {
                return this.amountModel.products;
            }

            return null;
        }

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        private pointsRatio: number;

        public isApplicationModeCO(): boolean {
            return this.identityService.inCentralOfficeMode();
        }

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $timeout: ng.ITimeoutService,
            protected $state: any,
            protected $translate: ng.translate.ITranslateService,
            protected reportRouterService: Meevo.Components.Common.ReportRouterService) {

            this.isCentralOffice = identityService.inCentralOfficeMode();
            this.purchasedANotBModel = new PurchasedANotB(this.$translate);
            
            // Get Marketing Drop Down UI
            this.dataService.customMethodData("api/BasicMarketing/UI", "GET", null).then((res) => {
                this.clientSelectionNames = res.data.events.filter((res) => res.id !== BasicMarketingClientSelectionEnum.ClientsAreDueIn);
                this.dateRanges = res.data.dateRanges;
                this.dateRangesCompare = res.data.dateRangesCompare;
                this.allowedControlTypes = res.data.allowedControlTypes;
                this.showEmmaButton = res.data.emmaEnabled;
                this.GetDateRangeSubset();
                var scope = this;
                this.$timeout(() => {
                    scope.GetClientCount();
                }, 500);

            });
            this.GetServiceCategories();
            this.GetServices();
            this.GetProductCategories();
            this.GetProducts();
            this.employeeCriteria = {showEmployeesOnly: true};
            this.serviceCriteria = {
                IsFrequencyOfVisitSet:
                       this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsAreDueIn
                    || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase
                    || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase
                    || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf
                    || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase
                    || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf ? true : null
            };
            this.productCriteria = {
                IsFrequencyOfVisitSet:
                    this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsAreDueIn
                ||  this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase
                ||  this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase
                ||  this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf
                ||  this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase
                ||  this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf ? true : null
            };

            this.employeeCriteria = { includeInactive: !this.hideInactiveEmployees, includeTerminated: !this.hideInactiveEmployees, showEmployeesOnly: true };
            this.serviceCriteria = { IsFrequencyOfVisitSet: this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsAreDueIn ? true : null, includeInactive: this.includeInactiveServices };
            this.serviceCategoryCriteria = { includeInactive: this.includeInactiveServices };
            this.discountsCriteria = { includeInactive: this.includeInactiveDiscounts };
            this.productCategoryCriteria = {};
            this.productCriteria = { includeDiscontinuedProducts: this.includeDiscontinuedProducts }

            for (var i = 1; i <= this.maxAmountOfVisits; i++) {
                this.numberOfVisitsOptions.push(i);
            }
            
            this.pointsRatio = this.getPointsRatio();
        }

        loadReport() {
            if (this.userCount > 0) {
                var request = this.GetRequestData(false);
                this.busyService.start();
                this.dataService.customMethodData("api/BasicMarketing/Clients", "POST", request).then(({ data }: { data: IEmailMarketingClient[] }) => {
                    if (data != null && data.length > 0)
                        return this.reportRouterService.routeToReportWithCustomData(this.meevoSecurityKeys.REPORTS_CLIENTS_DC080, {
                            clientIds: data
                                .map((row) => {
                                    return {
                                        id: row.Id,
                                        displayName: `${row.LastName}, ${row.FirstName}`
                                    }
                                })
                        });
                    else {
                        this.modalService.alert("BASICMARKETING_NOCLIENTSMATCHCRITERIA");
                    }
                }).finally(() => {
                    this.busyService.stop();
                });
            } else {
                this.modalService.alert("BASICMARKETING_NOCLIENTSMATCHCRITERIA");
            }
            
        }

        public updateServiceCriteria(getClientCount = true): void {
            this.serviceCriteria = (this.serviceCategory && this.serviceCategory.id) ? {
                serviceCategoryId: this.serviceCategory.id
            } : {};

        //this.service = this.AnyService;

            this.serviceCriteria['IsFrequencyOfVisitSet'] =
                   this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsAreDueIn
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf ? true : null;

            if (getClientCount) {
                this.GetClientCount();
            }

            this.serviceCriteria.includeInactive = this.includeInactiveServices;

        }

        public updateProductCriteria(getClientCount = true): void {
            this.productCriteria = (this.productCategory && this.productCategory.id) ? {
                productCriteriaId: this.productCriteria.id
            } : {};

            this.productVariant = this.AnyProductVariant;
            this.productCriteria['IsFrequencyOfVisitSet'] =
                   this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsAreDueIn
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoBecameAndWhoAreStillDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoWillBecomeDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsWhoseMostRecentPurchaseOf
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoBecameAndWhoAreStillDueToPurchase
                || this.clientSelectionId === BasicMarketingClientSelectionEnum.COClientsWhoseMostRecentPurchaseOf ? true : null;

            if (getClientCount) {
                this.GetClientCount();
            }

            this.productCriteria.includeDiscontinuedProducts = this.includeDiscontinuedProducts;
        }

        public toggleHideInactiveEmployees(): void {
            this.employeeCriteria = { includeInactive: !this.hideInactiveEmployees, includeTerminated: !this.hideInactiveEmployees, showEmployeesOnly: true };

            if (this.hideInactiveEmployees) {
                this.employee = this.AnyActiveEmployee;
            }
            else {
                this.employee = this.AnyEmployee;
            }

            this.GetClientCount();
        }

        public updateMembershipCriteria(): void {
            this.membershipCriteria = (this.membershipType && this.membershipType.id) ? {
                membershipTypeId: this.membershipType.id
            } : {}

            this.membershipCriteria.includeInactive = this.includeInactiveMemberships;
            this.GetClientCount();
        }

        public showDateRangeCompareSelect(id: number): boolean {
            var dateRanges = this.dateRanges.filter(x => x.eventId === id);
            var dateRangeCompares = this.dateRangesCompare.filter(x => x.eventId == id);
            if ((dateRangeCompares.length == 1)
                || (dateRanges.length === 1 && dateRanges[0].dateRangeEnum === Meevo.Model.BasicMarketingDateRangeSelectionEnum.Any)) {
                return false;
            }
            return dateRangeCompares.length > 0;
        }

        public getClientSelectionId(field: string): number {
            //console.log(field, this.clientSelectionId, Meevo.Model.BasicMarketingClientSelectionEnum[field]);
            if (Meevo.Model.BasicMarketingClientSelectionEnum[field]) {
                return Meevo.Model.BasicMarketingClientSelectionEnum[field];
            } else {
                return 0;
            }
        }

        public showTimeInterval(data: any): boolean {
            if (!data || data.length == 0) return false;
            return data.length === 1 && data.some(x => x.dateRangeEnum === 30505) ? false : true;
        }

        public GetServiceCategories(): void {
            var request = {
                pageNumber: 0,
                itemsPerPage: 10000
            };
            this.dataService.customMethodData("api/ServiceCategory/List", "POST", request).then(res => {
                this.serviceCategories = res.data;
            }).catch(e => {
                console.log('error getting service categories', e);
            });
        }

        public GetServices(): void {
            this.dataService.customMethodData("api/Service/List", "GET", null).then(res => {
                this.services = res.data;
            }).catch(e => {
                console.log('error getting services', e);
            });
        }

        public toggleIncludeInactiveItems(filteringElement): void {

            switch (filteringElement) {

                case "services":
                    this.purchasedANotBModel.includeInactiveServices = this.includeInactiveServices;
                    this.serviceCriteria = { IsFrequencyOfVisitSet: this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsAreDueIn ? true : null, includeInactive: this.includeInactiveServices };
                    this.serviceCategoryCriteria = { includeInactive: this.includeInactiveServices };

                    if (this.includeInactiveServices) {
                        this.service = this.AnyService;
                        this.serviceCategory = this.AnyServiceCategory;
                    }
                    else {
                        this.service = this.AnyActiveService;
                        this.serviceCategory = this.AnyActiveServiceCategory;
                    }

                    this.updateServiceCriteria();
                    break;

                case "membership":
                    this.membershipCriteria = { includeInactive: this.includeInactiveMemberships }
                    this.membershipTypeCriteria = { includeInactive: this.includeInactiveMemberships }

                    if (this.includeInactiveMemberships) {
                        this.membership = this.AnyMembership;
                        this.membershipType = this.AnyMembershipType;
                    }
                    else {
                        this.membership = this.AnyActiveMembership;
                        this.membershipType = this.AnyActiveMembershipType;
                    }
                    this.updateMembershipCriteria();
                    break;

                case "amountItemType":

                    console.log("amountItemType checkbox clicked")

                    this.amountItemTypeChanged()
                    break;

                case "giftCardType":
                    this.giftCardTypeCriteria = { includeInactive: this.includeInactiveGC }
                    this.giftCardType = this.includeInactiveGC ? this.AnyGiftCardType : this.AnyActiveGiftCardType
                    this.GetClientCount()
                    break;

                case "discounts":
                    this.discount = this.includeInactiveDiscounts ? this.AnyDiscount : this.AnyActiveDiscount
                    this.discountsCriteria = { includeInactive: this.includeInactiveDiscounts }
                    this.GetClientCount()
                    break;

                case "products":
                    this.purchasedANotBModel.includeDiscontinuedProducts = this.includeDiscontinuedProducts;
                    this.productCriteria = { includeDiscontinuedProducts: this.includeDiscontinuedProducts };
                    this.GetClientCount()
                    break;

                case "packages":
                    this.package = this.includeInactivePackage ? this.AnyPackage : this.AnyActivePackage;
                    this.GetClientCount();
                    break;

                default:
                    break;
            }

        }

        //ProductCategories
        public GetProductCategories(): void {
            var request = {
                pageNumber: 0,
                itemsPerPage: 10000
            };
            this.dataService.customMethodData("api/ProductCategory/List", "POST", request).then(res => {
                this.productCategories = res.data;
            }).catch(e => {
                console.log('error getting product categories', e);
            });
        }
        //Products
        public GetProducts(): void {
            this.dataService.customMethodData("api/Product/List", "GET", null).then(res => {
                this.services = res.data;
            }).catch(e => {
                console.log('error getting products', e);
            });
        }

        typeAheadPreProcessData(responseData, requestData, type, hideInactiveEmployees: boolean, includeInactive: boolean): any[] {
            if (!type) {
                return responseData;
            } else {
                type = type.toLowerCase();
            }

            if (requestData.pageNumber == 0) {
                switch (type) {
                    case "employee":
                        hideInactiveEmployees ? responseData.splice(0, 0, this.AnyActiveEmployee) : responseData.splice(0, 0, this.AnyEmployee)
                        break;
                    case "service":
                        includeInactive ? responseData.splice(0, 0, this.AnyService) : responseData.splice(0, 0, this.AnyActiveService);
                        break;
                    case "servicecategory":
                        includeInactive ? responseData.splice(0, 0, this.AnyServiceCategory) : responseData.splice(0, 0, this.AnyActiveServiceCategory);
                        break;
                    case "membershiptype":
                        includeInactive ? responseData.splice(0, 0, this.AnyMembershipType) : responseData.splice(0, 0, this.AnyActiveMembershipType)
                        break;
                    case "membership":
                        includeInactive ? responseData.splice(0, 0, this.AnyMembership) : responseData.splice(0, 0, this.AnyActiveMembership);
                        break;
                    case "giftcardtype":
                        includeInactive ? responseData.splice(0, 0, this.AnyGiftCardType) : responseData.splice(0, 0, this.AnyActiveGiftCardType);
                        break;
                    case "discount":
                        responseData.splice(0, 0, includeInactive ? this.AnyDiscount : this.AnyActiveDiscount);
                        break;
                    case "productvariant":
                        responseData.splice(0, 0, this.AnyProductVariant);
                        break;
                    case "productcategory":
                        responseData.splice(0, 0, this.AnyProductCategory);
                        break;
                    default:
                        break;
                }
            }

            if (type === "udf") {
                var indexesToRemove = [];
                for (var i = 0; i < responseData.length; i++) {
                    if (this.allowedControlTypes.indexOf(responseData[i].controlTypeEnum) === -1) {
                        indexesToRemove.push(i);
                    }
                }

                for (var i = indexesToRemove.length - 1; i >= 0; i--) {
                    responseData.splice(indexesToRemove[i], 1);
                }
            }

            return responseData;
        }

        public filterDropdown(whichOne: string): void {
            var data: any = null;
            var parentId: string = null;
            var childId: string = null;
            switch (whichOne) {
                case 'service':
                    data = this.services;
                    parentId = 'serviceCategoryId';
                    childId = 'serviceId';
                    break;
                default:
                    return null;
            }
            if (this[parentId] !== "0") {
                data = data.filter(x => x[parentId] == this[parentId]);
            }
            if (!data.some(x => x.id == this[childId])) {
                this[childId] = "0";
            }
            return data;
        }

        public GetRequestData(isCount: boolean): any {
            return {
                "ClientSelectionId": this.clientSelectionId,
                "RequireMarketingOptIn": this.requireMarketingOptIn,
                "DateRangeId": this.timeInterval,
                "DateRangeCompareId": this.GetDateRangeCompareId(this.clientSelectionId),
                "IncludeInactive": this.includeInactive,
                "NoFutureAppointments": this.noFutureAppointments,
                "NeverPurchasedRetail": this.neverPurchasedRetail,
                "GenderEnum": this.gender > "" ? this.gender : null,
                ServiceCategoryId: (this.serviceCategory && this.serviceCategory.id) ? this.serviceCategory.id.toUpperCase() : null,
                ServiceCategoryId_Tbl: this.serviceCategoryTblIds,
                ServiceId: (this.service && this.service.id) ? this.service.id.toUpperCase() : null,
                ProductCategoryId: (this.productCategory && this.productCategory.id) ? this.productCategory.id.toUpperCase() : null,
                ProductCategoryId_Tbl: this.productCategoryTblIds,
                VariantId: (this.productVariant && this.productVariant.id) ? this.productVariant.id.toUpperCase() : null,
                "MembershipTypeId": (this.membershipType && this.membershipType.id) ? this.membershipType.id.toUpperCase() : null,
                "MembershipId": (this.membership && this.membership.id) ? this.membership.id.toUpperCase() : null,
                "MembershipStatusId": (this.membershipStatusId) ? this.membershipStatusId.toUpperCase() : null,
                "EmployeeId": (this.employee && this.employee.id) ? this.employee.id.toUpperCase() : null,
                "NumberOfVisits": this.numberOfVisits,
                "NoVisitsSince": this.noVisitsSince,
                "DiscountId": (this.discount && this.discount.id) ? this.discount.id.toUpperCase() : null,
                "OnlyGrandFatheredMemberships": this.onlyGrandFatheredMemberships,
                "OnlySuspendedMemberships": this.onlySuspendedMemberships,
                "GiftCardTypeId": (this.giftCardType && this.giftCardType.id) ? this.giftCardType.id.toUpperCase() : null,
                "GiftCardStatus": this.giftCardStatus,
                "ExpireStartDate": this.expireStartDate,
                "ExpireEndDate": this.expireEndDate,
                "MinBalance": this.minBalance,
                "MaxBalance": this.maxBalance,
                "IncludeMembers": (!this.includeMembers && !this.includeNonMembers)
                || (this.includeMembers && this.includeNonMembers)
                    ? null : this.includeMembers === true,
                "MinPoints": this.getPointsToPost(this.minPoints),
                "MaxPoints": this.getPointsToPost(this.maxPoints),
                "IsForReferringClients": this.isForReferringClients,
                "IsCount": isCount,
                StartDate: this.startDate,
                EndDate: this.endDate,
                RequireSMSOptIn: this.optedInFotMessage,

                clientExportUDFs: this.clientExportUDFs,

                MinPrice: this.amountModel.min,
                MaxPrice: this.amountModel.max,
                ItemType_Tbl: this.amountItemType,
                ServiceList_Tbl: this.serviceListTbl,
                ServiceCategoryList_Tbl: this.amountModel.serviceCategories,
                ProductCategoryList_Tbl: this.amountModel.productCategories,
                ProductList_Tbl: this.productListTbl,
                EmployeeCategoryList_Tbl: this.amountModel.employeeCategories,
                EmployeeList_Tbl: this.amountModel.employees,

                PurchasedProductList_TBL: this.purchasedANotBModel.fullModel.ProductId,
                PurchasedProductCategoryList_TBL: this.purchasedANotBModel.fullModel.ProductCategoryId,
                NotPurchasedProductList_TBL: this.purchasedANotBModel.fullModel.NotProductId,
                NotPurchasedProductCategoryList_TBL: this.purchasedANotBModel.fullModel.NotProductCategoryId,
                PackageType_TId: (this.package && this.package.id) ? this.package.id : null,
                PurchasedServiceCategoryList_TBL: this.purchasedANotBModel.fullModel.ServiceCategoryId,
                PurchasedServiceList_TBL: this.purchasedANotBModel.fullModel.ServiceId,
                NotPurchasedServiceCategoryList_TBL: this.purchasedANotBModel.fullModel.NotServiceCategoryId,
                NotPurchasedServiceList_TBL: this.purchasedANotBModel.fullModel.NotServiceId,
                IsExpired: this.packageStatusModel,
                IsRemainingBalance: this.packageBalanceModel,

                RequireTextMarketingOptIn: this.requireTextMarketingOptIn,

                "IncludeInactiveEmployees": !this.hideInactiveEmployees,
                "IncludeInactiveAmountItemType": this.includeInactiveAmountItemType,
                "IncludeInactiveServices": this.includeInactiveServices,
                "IncludeInactiveMemberships": this.includeInactiveMemberships,
                "IncludeInactiveGC": this.includeInactiveGC,
                "IncludeInactivePackage": this.includeInactivePackage,
                "IncludeDiscontinuedProducts": this.includeDiscontinuedProducts,
                "IncludeInactiveDiscounts": this.includeInactiveDiscounts
            };
        }

        public GetClientList(): void {
            var request = this.GetRequestData(false);
            if (this.userCount > 0) {
                this.busyService.start();
                this.dataService.customMethodData("api/BasicMarketing/Clients", "POST", request).then((data) => {
                    if (data.data != null && data.data.length > 0)
                        this.$timeout(() => {
                            this.exportToCsv("Clients.csv", data.data.map((row) => {
                                delete row.Id;

                                return row;
                            }));
                        }, 1);
                    else {
                        this.modalService.alert("BASICMARKETING_NOCLIENTSMATCHCRITERIA");
                    }
                }).finally(() => {
                    this.busyService.stop();
                });
            } else {
                this.modalService.alert("BASICMARKETING_NOCLIENTSMATCHCRITERIA");
            }
            
        }

        public GetClientCount(): void {
            this.disableExport = true;

            if (!this.validate()) {
                return;
            }

            var request = this.GetRequestData(true);
            this.dataService.customMethodData("api/BasicMarketing/Clients", "POST", request).then((data) => {
                this.userCount = data.data;
                this.disableExport = false;
            });
        }

        //public GetDateRangeSubset(): void {
        //    console.log('GetDateRangeSubset')
        //    var displayName = "";
        //    this.dateRangeSubset = [];
        //    var nextArrayPos = 0;
        //    for (var i = 0; i < this.dateRanges.length; i++) {
        //        if (this.dateRanges[i].eventId == this.clientSelectionId) {
        //            this.dateRangeSubset[nextArrayPos] = this.dateRanges[i];
        //            nextArrayPos++;
        //        }
        //    }
        //    this.$timeout(() => {
        //        this.GetClientCount();
        //    }, 1);
        //}

        public UpdateClientCount(): void {
            this.filterDateRanges = [];
            this.$timeout(() => {
                this.filterDateRanges = this.GetDateRangeSubset();
                this.setDefaultValues();
                this.updateServiceCriteria(false);

                if (this.skipUpdateCountAfterSelect()) {
                    return;
                }

                this.$timeout(() => {
                    this.GetClientCount();
                }, 1);
            }, 1);
        }

        public GetDateRangeSubset(): any {
            return this.dateRanges.filter(x => x.eventId === this.clientSelectionId);
        }

        public GetDateRangeCompareSubset(): any {
            return this.dateRangesCompare.filter(x => x.eventId === this.clientSelectionId);
        }

        public hideCompareLabel(id: number): any {
            return this.hiddenCompareLabelIds.some(x => x == id) ? true : false;
        }

        //public GetDateRangeCompareDisplayName(clientSelectionId): string {
        //    if (this.clientSelectionIdsThatHideLabels.some(x => x == clientSelectionId)) return null;
        //    for (var i = 0; i < this.clientSelectionNames.length; i++) {
        //        if (this.clientSelectionNames[i].id == clientSelectionId) {
        //            return "BASICMARKETING_" + Model.BasicMarketingDateRangeCompareEnum[this.clientSelectionNames[i].dateRangeCompareEnum].toUpperCase();
        //        }
        //    }
        //    return "BASICMARKETING_WITHIN";
        //}

        public GetDateRangeCompareDisplayName(id): string {
            return "BASICMARKETING_" + (Model.BasicMarketingDateRangeCompareEnum[id].toUpperCase() || "WITHIN");
        }

        public GetDateRangeCompareId(clientSelectionId): number {
            var options = this.dateRangesCompare.filter(x => x.eventId == clientSelectionId)
            if (options.length === 1) {
                return options[0].dateRangeCompareEnum;
            } else {
                return this.dateRangeCompare;
            }

        }

        public GetDateClientSelectionDisplayName(code): string {
            return "BASICMARKETING_" + code.toUpperCase();
        }

        public exportToCsv(filename, rows) {
            if (!rows) return;
            rows.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1);
            var processRow = function (row, id) {

                var finalVal = '';
                for (var prop in row) {
                    if (Object.prototype.hasOwnProperty.call(row, prop)) {
                        finalVal += (row[prop].match && row[prop].match(/,|"/))
                            ? `"${row[prop].replace(/"/g, '""')}",`
                            : `${row[prop]},`;
                    }
                }
                return finalVal + '\n';
            };

            var csvFile = '', col = '';
            for (var prop in rows[0]) {
                if (prop.length > 4 && prop.substr(prop.length - 4, 4).toLowerCase() == "enum") {
                    col = prop.substr(0, prop.length - 4);
                } else {
                    col = prop;
                }

                csvFile += col + ",";
            }
            csvFile += '\n';

            for (var i = 0; i < rows.length; i++) {
                csvFile += processRow(rows[i], this.clientSelectionId);
            }

            var blob = new Blob([csvFile], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link["download"] !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        selectAllServiceCategories(): void {
            if (this.serviceCategory_Tbl.length !== this.serviceCategories.length) {
                this.serviceCategory_Tbl = this.serviceCategories.map(x => x.id);
            } else {
                this.serviceCategory_Tbl = ["0"];
            }
        }

        clientsIncludedChanged(checkbox: string) {
            if (!this.includeMembers && !this.includeNonMembers) {
                this.includeMembers = !(checkbox === 'membersOnly');
                this.includeNonMembers = !(checkbox === 'nonMembersOnly');
            }
        }

        public showAmountFilter(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/basicEmailMarketing/components/amount-filter-modal/amount-filter-modal.template.html',
                locals: {
                    amountModel: {...this.amountModel}
                },
                controller: 'meevo.plugins.basicEmailMarketing.AmountFilterModalController',
                controllerAs: '$ctrl',
                bindToController: true
            };

            this.modalService.showCustom(options)
                .then((amountModel) => {
                    this.amountModel = {...amountModel};
                    this.GetClientCount();
                });
        }

        public showSendToEmmaModal(): void {
            if (this.userCount > 0) {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: 'app/plugins/basicEmailMarketing/components/send-to-emma-modal/send-to-emma-modal.template.html',
                    locals: {
                        title: this.clientSelectionNames.find((item) => item.id === this.clientSelectionId).displayName,
                        clientExportRequest: this.GetRequestData(false)
                    },
                    controller: 'meevo.plugins.basicEmailMarketing.SendToEmmaModalController',
                    controllerAs: '$ctrl',
                    bindToController: true,
                };

                this.modalService.showCustom(options, null, true)
                    .then((res) => {
                        console.log('SendToEmmaModalController', res);
                    });
            } else {
                this.modalService.alert("BASICMARKETING_NOCLIENTSMATCHCRITERIA");
            }
            
        }

        public amountItemTypeChanged(): void {
            if (this.amountModel.amountItemType === AmountItemTypeEnum.Products) {
                this.amountModel.serviceCategories = null;
                this.amountModel.services = null;
            }

            if (this.amountModel.amountItemType === AmountItemTypeEnum.Services) {
                this.amountModel.productCategories = null;
                this.amountModel.products = null;
            }
            this.GetClientCount();
        }

        public addUdf(udf: IUserDefinedControl): void {
            if (!udf || !!this.udfsModel.find((u) => u.control_TId === udf.control_TId)) {
                this.newUdf = null;

                return;
            }

            if (this.udfsModel.length >= MAX_SELECT_UDFS) {
                this.modalService.alert('MESSAGE_CANNOT_SELECT_MORE_UDF');
                this.newUdf = null;

                return;
            }

            this.udfsModel.push({...udf, position: this.udfsModel.length + 1});
            this.newUdf = null;
        }

        public removeUdf(id: string): void {
            const idx = this.udfsModel.findIndex((udf) => udf.control_TId.toString() === id);
            if (idx === -1) {
                return;
            }

            this.udfsModel.splice(idx, 1);

            this.udfsModel
                .forEach((udf, idx) => udf.position = idx + 1);
        }

        public moveUdf(idx1: number, idx2: number): void {
            const temp = this.udfsModel[idx1];
            this.udfsModel[idx1] =  this.udfsModel[idx2];
            this.udfsModel[idx2] = temp;

            this.udfsModel
                .forEach((udf, idx) => udf.position = idx + 1);
        }

        private setDefaultValues() {
            this.noFutureAppointments = [
                Meevo.Model.BasicMarketingClientSelectionEnum.ClientsThatHaveReceivedServiceFromEmployee,
                Meevo.Model.BasicMarketingClientSelectionEnum.LastVisitNoFutureAppntmnt,
                Meevo.Model.BasicMarketingClientSelectionEnum.OverdueClients
            ].indexOf(this.clientSelectionId) !== -1;

            this.timeInterval = null;
            if (this.filterDateRanges.length) {
                this.timeInterval = (this.filterDateRanges.find((d) => d.isDefault) || this.filterDateRanges[0]).dateRangeEnum;
            }

            this.purchasedANotBModel.clearModel(this.clientSelectionId);
        }

        private validate(): boolean {
            if ([
                Meevo.Model.BasicMarketingClientSelectionEnum.ClientsPurchasedProductAnotProductB,
                Meevo.Model.BasicMarketingClientSelectionEnum.ClientsPurchasedServiceAnotServiceB,
            ].indexOf(this.clientSelectionId) !== -1) {
                return this.mainForm.$valid;
            }

            if (this.timeInterval === BasicMarketingDateRangeSelectionEnum.Custom) {
                return this.mainForm['dateRangeWithPresets'].$valid;
            }

            return true;
        }

        // meevo-date-range-with-presets triggers "onchange" after init
        private skipUpdateCountAfterSelect(): boolean {
            return !!this.filterDateRanges.find((d) => d.dateRangeEnum === BasicMarketingDateRangeSelectionEnum.Custom && !d.isDefault);
        }

        private getPointsRatio() : number {
            try {
                const dollarsValue: number = this.appSettings.APP_BUSINFOSETTINGS.clientPointSettings.dollarsValue || 0;
                const pointsValue: number = this.appSettings.APP_BUSINFOSETTINGS.clientPointSettings.pointsValue || 0;                
                return (pointsValue > 0 && dollarsValue > 0) ? dollarsValue / pointsValue : 1;
            } catch (e) {
                // if business info settings unavailable for whatever reason ratio is 1
                return 1;
            }
        }

        private getPointsToPost(val : number) : number {
            return parseFloat((val * this.pointsRatio).toPrecision(6)) || 0;
        }
    }

    angular.module('meevo.plugins.basicEmailMarketing')
        .controller('meevo.plugins.basicEmailMarketing.BasicEmailMarketingController', BasicEmailMarketingController);
}
